import { FC } from 'react'

import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import type { TourDocumentStatus } from 'shared/api/tours/document-data'
import { DATE_FORMAT_LIST } from 'shared/constants/dateFormatList'
import EmptyImage from 'shared/images/empty-image.webp'
import { dateFormat } from 'shared/lib/dateFormat'
import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'
import { Button } from 'shared/ui/button'
import { ImageOptimized } from 'shared/ui/image-optimized'

import s from './styles.module.scss'

export interface MyTourPreview {
  id: string
  status: TourDocumentStatus
  hotel: string
  startDate: string
  endDate: string
  nights: number
  tourists?: number
  image: string
}

interface Props {
  tour: MyTourPreview
  onClick: () => void
}

export const MyTourCard: FC<Props> = ({ tour, onClick }) => {
  const { t } = useTranslation()

  return (
    <Button
      type="button"
      variant="grey"
      className={s.card}
      onClick={onClick}
    >
      <ImageOptimized
        src={tour.image}
        alt=""
        errorImage={EmptyImage}
        width={40}
        height={40}
        wrapperClassName={s.image}
      />
      <span className={s.info}>
        <span className={clsx(s.title, 'bold-14')}>{tour.hotel}</span>
        <span className={clsx(s.description, 'regular-12')}>
          {dateFormat(tour.startDate, DATE_FORMAT_LIST.DATE_MONTH_SHORT)}
          {' – '}
          {dateFormat(tour.endDate, DATE_FORMAT_LIST.DATE_MONTH_SHORT)},{' '}
          {t('tours_block.night', { count: tour.nights })}
          {typeof tour.tourists === 'number' && (
            <>
              {', '}
              {t('tours_block.tourists_count', { count: tour.tourists })}
            </>
          )}
        </span>
      </span>
      <AppIcon
        id={AllIcons.ARROW_RIGHT}
        width={24}
        height={24}
        className={s.arrow}
      />
      <span className={clsx(s.status, 'semi-bold-12')}>
        {t(
          tour.status === 'IN_TRIP'
            ? 'tourDetails.inTrip'
            : 'tourDetails.upcoming',
        )}
      </span>
    </Button>
  )
}
